import React, { useState, useEffect, useRef } from 'react';
import AudioPlayer from './AudioPlayer';
import './AudioToggle.css';

const AudioToggle = () => {
  const [visible, setVisible] = useState(false);
  const containerRef = useRef(null);

  // Click outside: đóng hộp thoại
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target)
      ) {
        setVisible(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="audio-toggle-container" ref={containerRef}>
      <button
        className="audio-toggle-button"
        onClick={() => setVisible((v) => !v)}
      >
        <svg className="disc-icon" viewBox="0 0 24 24" width="1.5em" height="1.5em">
          <g fill="none">
            <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z"></path>
            <path fill="currentColor" d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12S6.477 2 12 2m0 2a8 8 0 1 0 0 16a8 8 0 0 0 0-16m0 6a2 2 0 1 1 0 4a2 2 0 0 1 0-4m-.56-3.493a1 1 0 0 1-.61 1.276a5.02 5.02 0 0 0-2.664 2.216a1 1 0 1 1-1.732-1.001a7.02 7.02 0 0 1 3.73-3.1a1 1 0 0 1 1.276.609"></path>
          </g>
        </svg>
      </button>

      <div
        className="audio-panel"
        style={{ display: visible ? 'block' : 'none' }}
      >
        <AudioPlayer />
      </div>
    </div>
  );
};

export default AudioToggle;
